module.exports = {
  PoNo: 'Номер заказа',
  ItemNo: 'Код SKU',
  JobNo: 'Номер магистральной операции',
  Supplier: 'Поставщик',
  LoadingPort: 'Порт отправления',
  DestinationPort: 'Порт назначения',
  WarehouseNo: 'Номер размещения на складе',
  State: 'Статус',
  OperationRequirement: 'Требования к операции',
  RequestedIncomeDate: 'Требуемое время размещения на складе',
  EstimatedIncomeDate: 'Планируемое время размещения на складе',
  ETD: 'Планируемое время отбытия из порта',
  LoadingDate: 'Время завершения упаковки',
  RequestedDeliveryDate: 'Требуемое время доставки',
  EstimatedDeliveryDate: 'Планируемое время доставки',
  POCreationDate: 'Время создания PO',
  DeliveryDate: 'Время получения',
  DateModified: 'Время обновления',
  Producer: 'Производитель',
  PackageEstimatedIncomeDate: 'Планируемое время готовности товара',
  IncomeDate: 'Фактическое время размещения на складе',
  WarehouseInState: 'Статус размещения на складе',
  DeliveryAddr: 'Адрес получения',
  IncomeDelayReason: 'Причина задержки размещения на складе',
  ContainerState: 'Статус контейнера',
  DepartureDelayReason: 'Причина задержки отбытия из порта',
  PleaseSelectTheOrderToDelete: 'Пожалуйста, выберите заказ для удаления',
  onlyOneOrderCanBeDeletedAtATime: 'Можно удалить только один заказ за раз',
  onlyCancelledOrdersCanBeDeleted: 'Удалить можно только отменённые заказы',
  areYouSureToDeleteThisOrder: 'Вы уверены, что хотите удалить этот заказ?',
  deleteOrder: 'Удалить заказ',
  Shipper: 'Отправитель',
  RelatedParty: 'Связанная сторона',
  Consignee: 'Получатель',
  EntrustingDate: 'Дата поручения'
}
